/** Meta 광고 소재 조사의 표시용 변환 — 날짜·게재기간·CTA 문구. */


/** ISO 두 개 → `2025.06.27 ~ 2026.08.18`. 한쪽만 있으면 그쪽만 */
export function formatDateRange(start: unknown, end: unknown): string {
  const from = String(start || '').slice(0, 10);
  const to = String(end || '').slice(0, 10);
  if (!from && !to) return '';
  if (from && to) return `${from.replace(/-/g, '.')} ~ ${to.replace(/-/g, '.')}`;
  return (from || to).replace(/-/g, '.');
}

/** 게재기간(초) → `417일`. 상세의 「활성 기간」 행 */
export function formatActiveDays(seconds: unknown): string {
  const total = Number(seconds) || 0;
  if (total <= 0) return '';
  const days = Math.max(1, Math.round(total / 86400));
  return `${days.toLocaleString('ko-KR')}일`;
}

/**
 * 카드 오른쪽 아래 — 진행중이면 `417일째`, 끝났으면 `417일간`.
 *
 * ⚠️ 당일 시작이면 초가 0이라 기간이 안 나온다. 진행중이고 시작일이 있으면 `1일째`로
 * 세운다 — "0일 게재"는 틀린 말이다.
 */
export function formatRunningDaysLabel(
  seconds: unknown,
  isActive: boolean,
  startDate: string,
): string {
  const total = Number(seconds) || 0;
  if (total <= 0) {
    return isActive && startDate ? '1일째' : '';
  }
  const days = Math.max(1, Math.round(total / 86400));
  const label = days.toLocaleString('ko-KR');
  return isActive ? `${label}일째` : `${label}일간`;
}

/**
 * 집행 일수 — 소재 상세 「집행」 칸의 셈. 색인 집행 일수(`adLifespanDays` · 첫 수집일부터)가 있으면 그것,
 * 없으면 게재기간(초)을 날로 반올림 · 최소 1.
 * ⚠️ 카드에 「N일째」를 적는 자리는 이 함수를 쓴다 — 상세를 열었을 때 같은 수가 보여야 한다.
 */
export function adRunDays(lifespanDays: unknown, durationSeconds: unknown): number {
  const lifespan = Number(lifespanDays);
  const base = lifespanDays != null && lifespanDays !== '' && Number.isFinite(lifespan) ? lifespan : (Number(durationSeconds) || 0) / 86400;
  return Math.max(1, Math.round(base));
}

/** `yyyyMMdd` → `2026.08.18` */
export function formatYmd(ymd: unknown): string {
  const digits = String(ymd || '').replace(/\D/g, '');
  if (digits.length !== 8) return '';
  return `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6, 8)}`;
}

